<template>
  <BaseModalEditCreate
    mode="edit"
    :title="`Move ${items.length} item${items.length === 1 ? '' : 's'}`"
    :is-modified="isModified"
    hide-save-button
    @dismiss-changes="onDismissChanges">
    <template #form>
      <div class="flex flex-col gap-3 max-h-[50vh] overflow-y-auto">
        <div
          v-for="set in sets"
          :key="set.id"
          class="h-6 text-sm font-light rounded-full hover:bg-slate-50 p-1.5 hover:text-theme-600 flex items-center group">
          <span class="group-hover:truncate">{{ set.name }}</span>

          <button
            type="button"
            class="h-6 ml-auto items-center font-medium uppercase rounded-full text-theme-700 bg-cyan-light px-1.5 py-1 border hidden group-hover:flex flex-shrink-0 text-xs"
            @click="onMove(set.id, set.minQuantity)">
            Move To
            <Icon icon="tabler:chevron-up" class="w-4 h-4 rotate-90" />
          </button>
        </div>
      </div>
    </template>
  </BaseModalEditCreate>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Icon } from '@iconify/vue';

import BaseModalEditCreate from '../common/BaseModalEditCreate.vue';

import { type AssortmentDetails } from '@/types/Materials';

const emit = defineEmits(['closeModal', 'move']);

type SetName = {
  name: string;
  id: string;
  minQuantity: number;
};

defineProps<{
  items: AssortmentDetails[];
  sets: SetName[];
}>();

const isModified = ref<boolean>(false);

function onDismissChanges() {
  emit('closeModal');
}

function onMove(setId: string, setMinQuantity: number) {
  emit('move', { id: setId, minQuantity: setMinQuantity });
}
</script>
